// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.page[data-v-162f0f0e] {\n  line-height: 40px;\n  text-align: center;\n  margin: 20px 0;\n}\n.page span[data-v-162f0f0e] {\n  float: left;\n  margin-left: 20px;\n}\n.page-num[data-v-162f0f0e]{\n  display: inline-block;\n  padding: 0 10px;\n  font-weight: 400;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
